import { ApiClient } from 'app/service/api-service'
import { TumHrmEndpoint } from './constant'
import {
  IParamsGetTradeUnionMember,
  IPayloadSyncAllTumHrm,
  IPayloadUpdateTumHrmMany,
  ITradeUnionMember,
} from './model'

export const requestSyncTradeUnionMember = (body?: {
  data: ITradeUnionMember[]
}) =>
  ApiClient.Post({
    url: TumHrmEndpoint.TUM_HRM_SAVE_MANY,
    body,
  })

export const requestGetHrmTradeUnionMemberList = (
  body: IParamsGetTradeUnionMember,
) =>
  ApiClient.Post({
    url: TumHrmEndpoint.SEARCH_TUM_HRM,
    body,
  })

export const requestUpdateHrmTradeUnionMember = (body?: ITradeUnionMember) =>
  ApiClient.Put({
    url: TumHrmEndpoint.UPDATE_TUM_HRM,
    body,
  })

export const requestUpdateIsSyncHrmTradeUnionMember = (
  body?: IPayloadUpdateTumHrmMany,
) =>
  ApiClient.Put({
    url: TumHrmEndpoint.UPDATE_IS_SYNC_TUM_HRM_MANY,
    body,
  })

export const requestUpdateIsSyncHrmTumAll = (body?: IPayloadSyncAllTumHrm) =>
  ApiClient.Put({
    url: TumHrmEndpoint.UPDATE_IS_SYNC_TUM_HRM_ALL,
    body,
  })
